import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const AssetActiveService = {
    getAssets: async (data) => axios.post(API_URL + "/asset-actives/apply", data).then(({data}) => data).catch(err => {throw err}),
};

export default AssetActiveService;